/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconAdjustmentsPlus = createReactComponent("outline", "adjustments-plus", "IconAdjustmentsPlus", [["path", { "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M6 4v4", "key": "svg-1" }], ["path", { "d": "M6 12v8", "key": "svg-2" }], ["path", { "d": "M13.958 15.592a2 2 0 1 0 -1.958 2.408", "key": "svg-3" }], ["path", { "d": "M12 4v10", "key": "svg-4" }], ["path", { "d": "M12 18v2", "key": "svg-5" }], ["path", { "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-6" }], ["path", { "d": "M18 4v1", "key": "svg-7" }], ["path", { "d": "M18 9v3", "key": "svg-8" }], ["path", { "d": "M16 19h6", "key": "svg-9" }], ["path", { "d": "M19 16v6", "key": "svg-10" }]]);

export { IconAdjustmentsPlus as default };
//# sourceMappingURL=IconAdjustmentsPlus.mjs.map
